import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {
  APP_BRANDSAFETYRATING_KEYS,
  APP_MAPPING_KEYS,
  APP_TRUEFALSE_KEYS,
  AppSummaryResponse,
  COLOR_MAP,
  CTV_BRANDSAFETYRATING_KEYS,
  CTV_MAPPING_KEYS,
  CTV_TRUEFALSE_KEYS,
  DEFAULT_APPSUMMARYRESPONSE,
  DOMAIN_BRANDSAFETYRATING_KEYS,
  DOMAIN_MAPPING_KEYS,
  DOMAIN_TRUEFALSE_KEYS,
  GivtSivtRate,
  RATING_LABEL_MAPPING,
  RiskSummaryItem,
  TopAdSize
} from '../APP_SUMMARY_RESPONSE';
import { AppService } from '../../../../services/app-service';
import { DomainService } from '../../../../services/domain-service';
import { CtvService } from '../../../../services/ctv-service';
import { ActivatedRoute } from '@angular/router';

declare var jQuery;

@Component({
  selector: 'app-app-summary-view',
  templateUrl: './app-summary-view.component.html',
  styleUrls: ['./app-summary-view.component.scss']
})
export class AppSummaryViewComponent implements OnInit, OnChanges {
  @Input() currentConfig: any;
  @Input() facets: any;
  @Input() loadingData: boolean;
  @Input() filterStrings: Array<string>;

  totalCount: any;
  appSummaryResponse: AppSummaryResponse;
  viewabilityChartIcon: string;
  riskRateMapping = RATING_LABEL_MAPPING;
  colorMapping = COLOR_MAP;
  brandSafetyRatingKeys = null;
  brandSafetyRatings = [];
  appStats: any;
  riskProgressCircleChartKey: string;
  riskSummaryItems: Array<RiskSummaryItem>;
  viewabilityLabel: string;

  constructor(
    private _appService: AppService,
    private _domainService: DomainService,
    private _ctvService: CtvService,
    private _route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.totalCount = 0;
    this.appSummaryResponse = DEFAULT_APPSUMMARYRESPONSE;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName === 'facets') {
        const currentValueStr = JSON.stringify(changes[propName].currentValue);
        const previousValueStr = JSON.stringify(
          changes[propName].previousValue
        );
        if (currentValueStr !== previousValueStr) {
          console.log('FACETS UPDATING...' + Math.random());
          this.fetchStats();
        }
      }
    }
  }

  fetchStats() {
    let service = null;
    let mappingKeys = null;
    let brandSafetyRatingKeys = null;
    let trueFalseKeys = null;
    const filterStrings = this.filterStrings.join('&');
    this.viewabilityLabel = '';
    if (this.currentConfig.key === 'apps') {
      service = this._appService.getAppStats(this.filterStrings);
      mappingKeys = APP_MAPPING_KEYS;
      brandSafetyRatingKeys = APP_BRANDSAFETYRATING_KEYS;
      trueFalseKeys = APP_TRUEFALSE_KEYS;
      this.riskProgressCircleChartKey = 'pixalateRating';
    } else if (this.currentConfig.key === 'ctv') {
      service = this._ctvService.getRokuStats(filterStrings);
      mappingKeys = CTV_MAPPING_KEYS;
      brandSafetyRatingKeys = CTV_BRANDSAFETYRATING_KEYS;
      trueFalseKeys = CTV_TRUEFALSE_KEYS;
      this.riskProgressCircleChartKey = 'pixalateRisk';
      this.viewabilityLabel = 'Est. SSAI Rate';
    } else if (this.currentConfig.key === 'domains') {
      service = this._domainService.getDomainStats(filterStrings);
      mappingKeys = DOMAIN_MAPPING_KEYS;
      brandSafetyRatingKeys = DOMAIN_BRANDSAFETYRATING_KEYS;
      trueFalseKeys = DOMAIN_TRUEFALSE_KEYS;
      this.riskProgressCircleChartKey = 'risk';
    }

    service.then(response => {
      this.appStats = response;
      this.brandSafetyRatings = [];
      this.brandSafetyRatingKeys = brandSafetyRatingKeys;
      const appSummaryResponse: AppSummaryResponse = JSON.parse(
        JSON.stringify(this.appSummaryResponse)
      );
      mappingKeys.forEach(mappingKey => {
        if (response[mappingKey]) {
          appSummaryResponse[mappingKey] = {
            L: 0,
            M: 0,
            H: 0
          };
          const keys = Object.keys(response[mappingKey]);
          this.sortRatingKeys(keys);
          keys.forEach(key => {
            appSummaryResponse[mappingKey][key] = response[mappingKey][key];
          });
          appSummaryResponse[mappingKey].showMedHigh =
            keys.length === 3 || (keys.length === 2 && keys.indexOf('L') >= 0);
          if (keys.length < 3) {
            appSummaryResponse[mappingKey].singleRating = keys[keys.length - 1];
          }
          const foundRating = this.brandSafetyRatingKeys.filter(
            rating => rating.key === mappingKey
          );
          if (foundRating && foundRating[0]) {
            this.brandSafetyRatings.push(foundRating[0]);
          }
        }
      });
      trueFalseKeys.forEach(trueFalseKey => {
        appSummaryResponse[trueFalseKey] = {
          T: 0,
          F: 0
        };
        if (response[trueFalseKey]) {
          const keys = Object.keys(response[trueFalseKey]);
          keys.forEach(key => {
            appSummaryResponse[trueFalseKey][key] = response[trueFalseKey][key];
          });
        } else if (this.facets[trueFalseKey]) {
          const keys = Object.keys(this.facets[trueFalseKey]);
          keys.forEach(key => {
            appSummaryResponse[trueFalseKey][key] =
              this.facets[trueFalseKey][key];
          });
        }
      });
      appSummaryResponse.givtSivtRate = new GivtSivtRate();
      appSummaryResponse.givtSivtRate.average = 0;
      appSummaryResponse.givtSivtRate.appsLess5percent = 0;
      if (response['givtSivtRate']) {
        appSummaryResponse.givtSivtRate.average = Math.abs(
          response['givtSivtRate'].average
        );
        appSummaryResponse.givtSivtRate.appsLess5percent =
          response['givtSivtRate']['[0,0.05]'];
      }
      if (response['ivtRate']) {
        appSummaryResponse.givtSivtRate.average = Math.abs(
          response['ivtRate'].average
        );
        appSummaryResponse.givtSivtRate.appsLess5percent =
          response['ivtRate']['[0,0.05]'];
      }
      if (response['givtRate']) {
        appSummaryResponse.givtRate = response['givtRate'].average;
      }
      if (response['sivtRate']) {
        appSummaryResponse.sivtRate = response['sivtRate'].average;
      }
      appSummaryResponse.nonGivtSivtViewability = 0;
      if (response['nonGivtSivtViewability']) {
        this.viewabilityChartIcon = '&#x2713;';
        appSummaryResponse.nonGivtSivtViewability =
          response['nonGivtSivtViewability']['average'];
      }
      if (response['ssaiRate']) {
        this.viewabilityChartIcon = '&#x2713;';
        appSummaryResponse.nonGivtSivtViewability =
          response['ssaiRate']['average'];
      }
      if (response['topAdSizes']) {
        appSummaryResponse.topAdSizes = new Array<TopAdSize>();
        const adSizeKeys = Object.keys(response['topAdSizes']);
        adSizeKeys.forEach(key => {
          if (key !== 'N/A') {
            const adSize = new TopAdSize();
            adSize.size = key;
            adSize.count = response['topAdSizes'][key];
            appSummaryResponse.topAdSizes.push(adSize);
          }
        });
      }
      setTimeout(() => {
        // jQuery('[data-toggle="tooltip"]').tooltip({animation: false, container: 'body', trigger: 'hover'});
      }, 100);
      this.totalCount = response['total'];
      this.appSummaryResponse = appSummaryResponse;
      this.processSummaryResponse(response);
    });
  }

  processSummaryResponse(response: any) {
    this.riskSummaryItems = [];
    if (this.currentConfig.key === 'domains') {
      if (response.trafficSource) {
        this.riskSummaryItems.push({
          class: 'color-blue',
          label: 'With Direct as Top Traffic Source',
          value: response.trafficSource.Direct
            ? response.trafficSource.Direct
            : 0
        });
        this.riskSummaryItems.push({
          class: 'color-blue',
          label: 'With Search as Top Traffic Source',
          value: response.trafficSource.Search
            ? response.trafficSource.Search
            : 0
        });
        this.riskSummaryItems.push({
          class: 'color-blue',
          label: 'With Social as Top Traffic Source',
          value: response.trafficSource.Social
            ? response.trafficSource.Social
            : 0
        });
        this.riskSummaryItems.push({
          class: 'color-blue',
          label: 'With Paid as Top Traffic Source',
          value: response.trafficSource.Paid ? response.trafficSource.Paid : 0
        });
      }
    } else if (this.currentConfig.key === 'apps') {
      if (response.hasPrivacyLink) {
        this.riskSummaryItems.push({
          showWarningIcon: response.hasPrivacyLink.F > 0,
          label: 'Without Privacy Policy',
          value: response.hasPrivacyLink.F ? response.hasPrivacyLink.F : 0
        });
      }
      if (response.isBlacklisted) {
        this.riskSummaryItems.push({
          class:
            !response.isBlacklisted.T || response.isBlacklisted.T <= 0
              ? 'color-L'
              : null,
          showWarningIcon: response.isBlacklisted.T > 0,
          label: 'Blocklisted',
          value: response.isBlacklisted.T ? response.isBlacklisted.T : 0
        });
      }
      if (response.isPrivateDomain) {
        this.riskSummaryItems.push({
          showWarningIcon: response.isPrivateDomain.T > 0,
          label: 'With Private Domain',
          value: response.isPrivateDomain.T ? response.isPrivateDomain.T : 0
        });
      }
      if (response.isExistInAppStore) {
        this.riskSummaryItems.push({
          showWarningIcon: true,
          label: 'Not in App Store',
          value: response.isExistInAppStore.F ? response.isExistInAppStore.F : 0
        });
      }
    } else if (this.currentConfig.key === 'ctv') {
      if (response.revenueSource) {
        if (!response.revenueSource.Ads) {
          response.revenueSource.Ads = 0;
        }
        this.riskSummaryItems.push({
          class:
            response.isAdsDetected.T <= 0 || !response.isAdsDetected.T
              ? 'color-blue'
              : null,
          showWarningIcon: response.isAdsDetected.T > 0,
          label: 'Has Ads',
          value: response.isAdsDetected.T ? response.isAdsDetected.T : 0
        });
        if (!response.revenueSource.InAppSubscriptions) {
          response.revenueSource.InAppSubscriptions = 0;
        }
        this.riskSummaryItems.push({
          class:
            response.revenueSource.InAppSubscriptions <= 0
              ? 'color-blue'
              : null,
          showWarningIcon: response.revenueSource.InAppSubscriptions > 0,
          label: 'Has In-app Subscriptions',
          value: response.revenueSource.InAppSubscriptions
            ? response.revenueSource.InAppSubscriptions
            : 0
        });
      }
      if (response.isCvaaCompliant) {
        if (!response.isCvaaCompliant.F) {
          response.isCvaaCompliant.F = 0;
        }
        const device = this._route.snapshot.params['param1'];
        if (device === 'roku') {
          this.riskSummaryItems.push({
            class: response.isCvaaCompliant.F <= 0 ? 'color-blue' : null,
            showWarningIcon: response.isCvaaCompliant.F > 0,
            label: 'Not CVAA Compliant',
            value: response.isCvaaCompliant.F ? response.isCvaaCompliant.F : 0
          });
        }
      }
      if (response.hasPrivacyLink) {
        if (!response.hasPrivacyLink.F) {
          response.hasPrivacyLink.F = 0;
        }
        this.riskSummaryItems.push({
          class: response.hasPrivacyLink.F <= 0 ? 'color-blue' : null,
          showWarningIcon: response.hasPrivacyLink.F > 0,
          label: 'Without Privacy Policy',
          value: response.hasPrivacyLink.F ? response.hasPrivacyLink.F : 0
        });
      }

      this.appSummaryResponse.topAdSizes = []; // No AdSizes to display;
      this.appSummaryResponse.hasAdsTxt =
        this.appSummaryResponse['isAdsTxtEnabled'];
      this.appSummaryResponse.appDescriptionBrandSafetyRating =
        this.appSummaryResponse['brandSafetyRisk'];
    }
  }

  sortRatingKeys(keys: Array<string>) {
    keys.sort((a, b) => {
      if (a !== b) {
        if (a === 'L' || (a === 'M' && b === 'H')) {
          return -1;
        } else if (a === 'M' && b === 'L') {
          return 1;
        } else if (a === 'H') {
          return 1;
        } else {
          return 1;
        }
      } else {
        return 0;
      }
    });
  }
}
